import * as React from 'react';
import { ValueProperty } from '../common/types';
import { toHex } from 'ui/common/hex-converter';
import styles from './badge.scss';
import { Tooltip, TooltipDirections } from 'ui/common/tooltip/tooltip';

export interface BadgeProps {
  title?: string;
  tooltip?: string;
  tooltipDirection?: TooltipDirections;
  filled?: boolean;
  backgroundColor?: number;
  foregroundColor?: number;
  text?: ValueProperty;
}

export class Badge extends React.PureComponent<BadgeProps> {
  public static defaultProps: Partial<BadgeProps> = {
    filled: true
  };

  public render() {
    const {
      title,
      filled,
      tooltip,
      tooltipDirection,
      text,
      backgroundColor,
      foregroundColor
    } = this.props;

    const fill = !!filled ? backgroundColor && toHex(backgroundColor) : 'transparent';
    const stroke = !!filled ? 'transparent' : !!backgroundColor && toHex(backgroundColor);
    const textFill = !!foregroundColor ? toHex(foregroundColor) : 'black';

    const circle = <svg className="badge-illustration" viewBox="0 0 50 50" preserveAspectRatio="">
                      <circle cx="25" cy="25" r="23" fill={fill} stroke={stroke} strokeWidth="4px"/>
                      <text className={styles.strong} x="25" y="32" fill={textFill} fontSize="22">{String(text)}</text>
                    </svg>;

    return (
      <Tooltip className={styles.tooltipOverwrite} title={tooltip} delayed={true} direction={tooltipDirection} narrow={true} center={true}>
        <div className={`${styles.badgeWrapper} badge-wrapper`}>
          <label className={styles.label}>{title}</label>
          {circle}
        </div>
      </Tooltip>
    );
  }
}
